var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99996 4.83366C9.45829 4.83366 9.83329 5.20866 9.83329 5.66699V9.00033C9.83329 9.45866 9.45829 9.83366 8.99996 9.83366C8.54163 9.83366 8.16663 9.45866 8.16663 9.00033V5.66699C8.16663 5.20866 8.54163 4.83366 8.99996 4.83366ZM8.99163 0.666992C4.39163 0.666992 0.666626 4.40033 0.666626 9.00033C0.666626 13.6003 4.39163 17.3337 8.99163 17.3337C13.6 17.3337 17.3333 13.6003 17.3333 9.00033C17.3333 4.40033 13.6 0.666992 8.99163 0.666992ZM8.99996 15.667C5.31663 15.667 2.33329 12.6837 2.33329 9.00033C2.33329 5.31699 5.31663 2.33366 8.99996 2.33366C12.6833 2.33366 15.6666 5.31699 15.6666 9.00033C15.6666 12.6837 12.6833 15.667 8.99996 15.667ZM9.83329 13.167H8.16663V11.5003H9.83329V13.167Z",
    fill: "#F84960"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b101b1324c297771a8c7f91316ed2aa5.svg";
export { ForwardRef as ReactComponent };